import type { Endpoints } from "../api";
import { APP_VERSION } from "../config";
import { CopyField } from "./ui/CopyField";
import { Icon } from "./ui/Icon";

export function PlatformSettingsView({ endpoints }: { readonly endpoints: Endpoints | null }) {
  return (
    <div className="settings-page">
      <section className="page-heading compact-heading"><div><p className="eyebrow">PLATFORM</p><h2>平台配置</h2><p>控制面与消息数据面相互隔离，应用配置不占用消息 D1 分片。</p></div></section>
      <div className="settings-layout">
        <section className="surface-card settings-panel"><header><span><Icon name="globe" /></span><div><h3>公共服务端点</h3><p>用于客户端和业务服务端接入</p></div></header><div className="copy-field-grid"><CopyField label="OIDC Issuer" value={endpoints?.issuer ?? "https://sso.smartflx.com"} /><CopyField label="IM API" value={endpoints?.api ?? "https://api.im.smartflx.com"} /><CopyField label="WebSocket" value={endpoints?.webSocket ?? "wss://ws.im.smartflx.com"} /><CopyField label="控制台版本" value={APP_VERSION} /></div></section>
        <aside className="surface-card resource-panel"><span className="resource-icon"><Icon name="activity" size={22} /></span><h3>资源边界</h3><p>消息 D1、Queue 与 ConnDO 当前均使用 3 个分片。开放平台使用独立控制面 D1，只保存应用配置、所有权和审计记录。</p><dl><div><dt>D1 分片</dt><dd>3</dd></div><div><dt>Queue 分片</dt><dd>3</dd></div><div><dt>控制面</dt><dd>独立</dd></div></dl></aside>
      </div>
    </div>
  );
}
